import { useState } from 'react'
import { useLogin } from '../../hooks/useLogin'
import { auth } from '../../firebase/config'
import { sendPasswordResetEmail } from 'firebase/auth'
import { Helmet } from 'react-helmet'

// styles
import styles from './Login.module.css'


export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { login, error, isPending } = useLogin()
  const [success, setSuccess] = useState('')
  const [resetError, setError] = useState('')

  const handleSubmit = (e) => {
    setError('')
    setSuccess('')
    e.preventDefault()
    login(email, password)
  }
  const handleForgotPassword = async() => {
    setError('')
    setSuccess('')
    try {
      await sendPasswordResetEmail(auth, email)
      setSuccess('Password reset email sent successfully')
      console.log('Password reset email sent successfully')

    } catch (error) {
      setError('Error resetting password')
      console.log('Error resetting password', error)
    }
  }

  return (
    <div>
      <Helmet>
        <title>Log In to Your Crifty Account | Secure Bookkeeping Access</title>
        {/*-- SEO Meta Tags --*/}
        <meta name="description" content="Securely log in to your Crifty account to manage your bookkeeping, track expenses, and view your financial dashboard." />
        <meta name="keywords" content="log in to crifty, crifty login, secure login, bookkeeping login, access my account, expense tracker login" />
        <meta name="author" content="Crifty" />
        <link rel="canonical" href="https://crifty.com/login" />

        {/*-- Open Graph / Social Meta Tags (Improved) */}
        <meta property="og:title" content="Log In to Your Crifty Account | Secure Bookkeeping Access" />
        <meta property="og:description" content="Securely access your Crifty account to manage your bookkeeping and financial dashboard." />
        <meta property="og:image" content="https://crifty.com/OG-crifty.webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Secure login to Crifty Bookkeeping" />
        <meta property="og:url" content="https://crifty.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Crifty" />

        {/*-- Twitter Meta Tags --*/}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Log In to Your Crifty Account | Secure Bookkeeping Access" />
        <meta name="twitter:description" content="Securely access your Crifty account to manage your bookkeeping." />
        <meta name="twitter:image" content="https://crifty.com/OG-crifty.webp" />
        <meta name="twitter:site" content="@CriftyApp" />

        {/* Structured Data for Login Page */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "Log In to Crifty",
              "description": "Secure login page for Crifty Bookkeeping software.",
              "url": "https://crifty.com/login",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://crifty.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Log In"
                  }
                ]
              }
            }
          `}
        </script>
      </Helmet>        

      <form className={styles['login-form']} onSubmit={handleSubmit}>
        <h2>Login</h2>
        <label>
          <span>Email : </span>
          <input
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            autoComplete="email"
          />
        </label>
        <label>
          <span>Password : </span>
          <input
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            autoComplete="current-password"
          />
        </label>
        <div className="main-container">
          {!isPending && <button /*onClick={handleSubmit}*/ className="btn">Login</button>}
          {isPending && <button className="btn" disabled>Loading</button>}
        </div>      
      </form>
      <div className="main-container">
        <button className="btn" onClick={handleForgotPassword}>Forgot Password</button>
        
      </div>
      <div className="main-container">
        {error && <div className="error">{error}</div>}
        {success && <p className="success">{success}</p>}
        {resetError && <p className="error">{resetError}</p>}
      </div>
      
      
    </div>
    )
}